var EnvService = (function () {
    function EnvService($localStorage) {
        this.$localStorage = $localStorage;
        this.notifications = 'on';
        this.loaded = { env: false, config: false, topic: false };
        this.topics = [];
        this.user = {
            email: null,
            name: null,
            token: null,
            loggedIn: false,
            access: {},
            allowed: false,
            approver: false,
            termsOk: true
        };
        this.promises = {};
    }
    EnvService.prototype.getRoleAsString = function () {
        if (this.user.access.bpsoAdmin) {
            return 'BPSO Administrator';
        }
        else if (this.user.access.nonBpsoAdmin) {
            return 'Non-BPSO Administrator';
        }
        else if (this.user.access.bpsoApprover) {
            return 'BPSO Approver';
        }
        else if (this.user.access.nonBpsoApprover) {
            return 'Non-BPSO Approver';
        }
        else if (this.user.access.reader) {
            return 'Reader';
        }
        else if (this.user.access.systemAdmin) {
            return 'System Administrator';
        }
    };
    /**
     * getDefaultQueue - Get default queue for a user based on their access.  My Queue for Admin; Workitems for everyone else
     *
     * @return {type}  description state id for queue/:id
     */
    EnvService.prototype.getDefaultQueue = function () {
        if (this.user.access.bpsoAdmin || this.user.access.nonBpsoAdmin) {
            return 'myqueue';
        }
        else if (this.user.approver) {
            return 'approval';
        }
        return 'workitems'; //probably end up as Teams' Queue...
    };
    EnvService.prototype.setUser = function (obj) {
        for (var prop in obj) {
            if (!obj.hasOwnProperty(prop)) {
                continue;
            }
            ;
            //  console.log(prop + ' = ' + obj[prop]);
            this.user[prop] = obj[prop];
        }
        this.loaded.env = true;
    };
    EnvService.prototype.revokeUser = function () {
        this.user = {
            email: null,
            name: null,
            token: null,
            loggedIn: false,
            access: [],
            allowed: false,
            approver: false,
            uid: null
        };
        this.$localStorage.$reset();
    };
    EnvService.prototype.updateLoaded = function (type, value) {
        this.loaded[type] = value;
    };
    EnvService.$inject = [
        '$localStorage',
    ];
    return EnvService;
}());
angular
    .module('application')
    .service('env', EnvService);

//# sourceMappingURL=env.js.map
